module.exports = __webpack_public_path__ + "static/media/DownloadNow_elImage_575651.fd494cb6.png";